function updateControls(track, previous, next) {
  const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
  previous.disabled = track.scrollLeft <= 1;
  next.disabled = track.scrollLeft >= maxScroll - 1;
}

function initSection(section) {
  if (section.dataset.multimediaReady === "true") return;

  const track = section.querySelector("[data-multimedia-track]");
  const previous = section.querySelector('[data-multimedia-rail="previous"]');
  const next = section.querySelector('[data-multimedia-rail="next"]');
  if (!track || !previous || !next) return;

  const sync = () => updateControls(track, previous, next);
  const scroll = direction => {
    const card = track.querySelector(".multimedia-card");
    const styles = getComputedStyle(track);
    const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
    const step = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.75;
    track.scrollBy({ left: step * direction, behavior: "smooth" });
  };

  previous.addEventListener("click", () => scroll(-1));
  next.addEventListener("click", () => scroll(1));
  track.addEventListener("scroll", sync, { passive: true });
  window.addEventListener("resize", sync);
  section.dataset.multimediaReady = "true";
  sync();
}

export default function initMultimedia(root = document) {
  root.querySelectorAll("[data-multimedia-section]").forEach(initSection);
}
